import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { en, fr } from "vuetify/locale";
import { createVuetify, ThemeDefinition } from "vuetify";
import { VBtn } from "vuetify/components";

const lightTheme: ThemeDefinition = {
    dark: false,
    colors: {
        primary: "#1867C0",
    },
};

export default createVuetify({
    aliases: {
        VBtnSecondary: VBtn,
    },
    defaults: {
        VBtn: {
            size: "large",
            rounded: true,
            block: true,
            class: ["font-weight-bold"],
        },
        VBtnSecondary: {
            size: "large",
            variant: "outlined",
            rounded: true,
            block: true,
            class: ["font-weight-bold"],
        },
        VTextField: {
            variant: "outlined",
            rounded: true,
            class: ["mb-2"],
        },
    },
    theme: {
        defaultTheme: "lightTheme",
        themes: { lightTheme },
    },
    locale: {
        fallback: "en",
        messages: { fr, en },
    },
});
